<template>
  <span
    class="ins-tip"
    :class="mode"
    :data-tip="mode === 'hover' ? resolved : null"
    tabindex="0"
    role="button"
    :aria-label="resolved"
    @click.stop="mode === 'click' ? toggle() : null"
    @blur="open = false"
  >
    <span v-if="mode === 'click' && open" class="ins-tip-pop" @click.stop>{{ resolved }}</span>
  </span>
</template>

<script>
/* Shared info bubble for field/metric names across the Insights reports.
 *  - mode="hover" (default): a small ⓘ that reveals a CSS tooltip on hover (Work Order Insights style).
 *  - mode="click": a small ⓘ that toggles a popover on click (Manufacturing Insights style).
 * Resolve text via `text`, or via `termKey` looked up in a `glossary` object. */
export default {
  name: "InsInfoTip",
  props: {
    text: { type: String, default: "" },
    termKey: { type: String, default: "" },
    glossary: { type: Object, default: () => ({}) },
    mode: { type: String, default: "hover" }, // 'hover' | 'click'
  },
  data() {
    return { open: false };
  },
  computed: {
    resolved() {
      if (this.text) return this.text;
      if (this.termKey && this.glossary) return this.glossary[this.termKey] || "";
      return "";
    },
  },
  methods: {
    toggle() { this.open = !this.open; },
  },
};
</script>

<style scoped>
.ins-tip {
  display: inline-flex; align-items: center; justify-content: center;
  width: 13px; height: 13px; margin-left: 4px; border-radius: 50%;
  border: 1px solid #b6c0ca; color: var(--ins-label, #7a828b);
  font-size: 9px; font-weight: 700; font-style: italic;
  font-family: Georgia, "Times New Roman", serif;
  cursor: help; position: relative; vertical-align: middle; user-select: none; line-height: 1;
}
.ins-tip.click { cursor: pointer; }
.ins-tip::before { content: "i"; }
/* hover tooltip via data-tip */
.ins-tip.hover::after {
  content: attr(data-tip);
  position: absolute; top: 150%; left: 50%; transform: translateX(-50%);
  width: max-content; max-width: 240px;
  background: #2a2f36; color: #fff; text-align: left;
  font-family: inherit; font-style: normal; font-weight: 400; font-size: 11px; line-height: 1.35;
  text-transform: none; letter-spacing: normal;
  padding: 6px 9px; border-radius: 6px; box-shadow: 0 3px 12px rgba(0,0,0,.28);
  white-space: normal; opacity: 0; visibility: hidden; transition: opacity .12s ease;
  z-index: 200; pointer-events: none;
}
.ins-tip.hover:hover::after, .ins-tip.hover:focus::after { opacity: 1; visibility: visible; }
/* click popover */
.ins-tip-pop {
  position: absolute; top: 150%; left: 50%; transform: translateX(-50%);
  width: max-content; max-width: 260px;
  background: #2a2f36; color: #fff; text-align: left;
  font-family: sans-serif; font-style: normal; font-weight: 400; font-size: 11px; line-height: 1.4;
  text-transform: none; letter-spacing: normal;
  padding: 8px 10px; border-radius: 6px; box-shadow: 0 4px 14px rgba(0,0,0,.32);
  white-space: normal; z-index: 300;
}
html.dark-mode .ins-tip { border-color: #4a525c; color: #aab3bd; }
html.dark-mode .ins-tip.hover::after, html.dark-mode .ins-tip-pop { background: #0f1216; box-shadow: 0 3px 12px rgba(0,0,0,.5); }
</style>
